import React, { useState, useEffect } from "react";
import { SectionHeading } from "../UI/Card";

const OffersCarousel = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("FLIGHT");
  const [showAll, setShowAll] = useState(false);

  const categories = [
    { name: "Flights", value: "FLIGHT" },
    { name: "Hotels", value: "HOTEL" },
    { name: "Bus", value: "BUS" },
  ];

  const fetchOffers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        setOffers([]);
        setLoading(false);
        return;
      }

      const response = await fetch(
        "https://app.rasutrip.com/api/v1/user/special-offer",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      setOffers(data.offers || []);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setOffers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const filteredOffers = showAll
    ? offers
    : offers.filter((offer) => offer.applicableFor === activeCategory);

  const handleCategoryClick = (categoryValue) => {
    setActiveCategory(categoryValue);
    setShowAll(false);
  };

  if (loading) {
    return (
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 py-14 flex items-center justify-center h-48">
        <div className="animate-spin rounded-full h-9 w-9 border-2 border-brand-200 border-t-brand-600" />
        <span className="ml-3 text-ink-500 text-sm">Loading offers...</span>
      </div>
    );
  }

  if (offers.length === 0) return null;

  return (
    <section className="max-w-[1280px] mx-auto px-5 sm:px-6 py-14">
      <SectionHeading
        eyebrow="Save More"
        title="Offers for you"
        className="mb-8"
        action={
          <div className="flex flex-wrap items-center gap-2">
            {categories.map((cat) => (
              <button
                key={cat.value}
                onClick={() => handleCategoryClick(cat.value)}
                className={`px-4 py-2 text-sm font-semibold rounded-full border transition shrink-0 ${
                  !showAll && activeCategory === cat.value
                    ? "bg-brand-600 text-white border-brand-600"
                    : "bg-white text-ink-600 border-ink-200 hover:border-brand-300 hover:text-brand-700"
                }`}
              >
                {cat.name}
              </button>
            ))}
            <button
              onClick={() => setShowAll(!showAll)}
              className="text-brand-600 font-semibold text-sm hover:text-brand-700 transition inline-flex items-center gap-1 shrink-0"
            >
              {showAll ? "Show Less" : "View All"}
              <span>&rarr;</span>
            </button>
          </div>
        }
      />

      <div className="mt-6 flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {filteredOffers.length === 0 ? (
          <div className="w-full text-center py-10 text-ink-400 text-sm">
            No offers available in this category.
          </div>
        ) : (
          filteredOffers.map((offer) => (
            <div
              key={offer._id}
              className="flex-1 min-w-[280px] max-w-sm rounded-2xl overflow-hidden bg-white border border-ink-100 shadow-card hover:shadow-card-hover transition-all duration-200 cursor-pointer"
            >
              <img
                src={offer.image}
                alt="Offer"
                className="w-full h-40 object-cover"
              />
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default OffersCarousel;
